import StoryCompanyBackground from './StoryCompanyBackground';
import './company-background.scss';

export default StoryCompanyBackground;
